<template>
  <div>
    <AllInfo ref="moreinfoRef" :info="clickInfo"> </AllInfo>
    <!-- 左侧菜单-->

    <transition enter-active-class="bounceInLeft slower" leave-active-class="bounceOutLeft slower">
      <div class="left_info animated" v-show="isShow">
        <div class="close_btn"><i class="el-icon-close" @click="hide"></i> </div>
        <div class="left_menu_item_carousel card">
          <ImgList :imgUrl="templeData.picture"> </ImgList>
        </div>
        <div class="left_menu_item card ">
          <div class="left_btn">
            <!-- 聚焦庙宇 -->
            <span @click="zoomIn()">{{$t("templeinfo.focus")}}</span>
            <!-- 缩小地图 -->
            <span @click="zoomOut()">{{$t("templeinfo.reduce")}}</span>
            <!-- <span>相关链接</span> -->
            <!-- 更多信息 -->
            <span @click="getMoreInfo()">{{$t("templeinfo.more")}}</span>
          </div>
        </div>
        <div class="left_menu_item">
          <div class="table_box roll">
            <table>
              <tr>
                <!-- 名称 -->
                <th>{{$t("templeinfo.name")}}</th>
                <td>{{templeData.name}}</td>
              </tr>
              <tr>
                <!-- 洲 -->
                <th>{{$t("templeinfo.continent")}}</th>
                <td>{{templeData.continent}}</td>
              </tr>
              <tr>
                <!-- 国家 -->
                <th>{{$t("templeinfo.country")}}</th>
                <td>{{templeData.country}}</td>
              </tr>
              <tr>
                <!-- 省、州 -->
                <th>{{$t("templeinfo.province")}}</th>
                <td>{{templeData.province}}</td>
              </tr>
              <tr>
                <!-- 市 -->
                <th>{{$t("templeinfo.city")}}</th>
                <td>{{templeData.city}}</td>
              </tr>
              <tr>
                <!-- 地址 -->
                <th>{{$t("templeinfo.address")}}</th>
                <td>{{templeData.address}}</td>
              </tr>
              <tr>
                <!-- 修建年代 -->
                <th>{{$t("templeinfo.years")}}</th>
                <td>{{templeData.years}} （{{templeData.dynasty}}）</td>
              </tr>
              <tr>
                <!-- 父庙 -->
                <th>{{$t("templeinfo.father")}}</th>
                <td>{{templeData.father_name}}</td>
              </tr>
              <tr>
                <!-- 上传者 -->
                <th>{{$t("templeinfo.uploader")}}</th>
                <td>{{templeData.uploader}}</td>
              </tr>
              <tr>
                <!-- 描述 -->
                <th>{{$t("templeinfo.description")}}</th>
                <td>{{templeData.description}}</td>
              </tr>
            </table>
          </div>
        </div>

      </div>
    </transition>

    <div class="more_info animated fadeInLeft" v-show="moreInfoShow">

      <div class="menu_item card">
        <!-- 人文历史： -->
        <div class="more_title"> {{$t("templeinfo.history")}}：</div>

        <div class="more_table">
          <table>
            <tr>
              <!-- 例祭 -->
              <th>{{$t("templeinfo.sacrifice")}}</th>
              <td>{{moreInfo.sacrifice}}</td>
            </tr>
            <tr>
              <!-- 是否迁徙 -->
              <th>{{$t("templeinfo.migration")}}</th>
              <td>{{moreInfo.migration == "1"?"是":"否"}}</td>
            </tr>
            <tr>
              <!-- 迁徙原址 -->
              <th>{{$t("templeinfo.migrationRoot")}}</th>
              <td>{{moreInfo.migrationRoot}}</td>
            </tr>
            <tr>
              <!-- 迁徙原因 -->
              <th>{{$t("templeinfo.migrationReason")}}</th>
              <td>{{moreInfo.migrationReason}}</td>
            </tr>
            <tr>
              <!-- 保存状况 -->
              <th>{{$t("templeinfo.saveStatr")}}</th>
              <!-- <td>{{moreInfo.saveStatr}}</td> -->
              <td>{{common.dictionary("保存状况", moreInfo.saveStatr)}}</td>
            </tr>
            <tr>
              <!-- 是否修缮 -->
              <th>{{$t("templeinfo.repair")}}</th>
              <td>{{moreInfo.repair == "1"?"是":"否"}}</td>
            </tr>
            <tr>
              <!-- 修缮记录 -->
              <th>{{$t("templeinfo.repairRecord")}}</th>
              <td>{{moreInfo.repairRecord}}</td>
            </tr>
            <tr>
              <!-- 损坏类型 -->
              <th>{{$t("templeinfo.damageType")}}</th>
              <!-- <td>{{moreInfo.damageType}}</td> -->
              <td>{{common.dictionary("损坏原因类型", moreInfo.damageType)}}</td>
            </tr>
            <tr>
              <!-- 损坏原因 -->
              <th>{{$t("templeinfo.damageReason")}}</th>
              <td>{{moreInfo.damageReason}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="menu_item card">
        <!-- 建筑风格： -->
        <div class="more_title"> {{$t("templeinfo.style")}}：</div>

        <div class="more_table">
          <table>
            <tr>
              <!-- 建筑宽度 -->
              <th>{{$t("templeinfo.buildWidth")}}</th>
              <td>{{moreInfo.buildWidth}}m</td>
              <!-- 建筑长度 -->
              <th>{{$t("templeinfo.buildLength")}}</th>
              <td>{{moreInfo.buildLength}}m</td>
            </tr>
            <tr>
              <!-- 建筑层数 -->
              <th>{{$t("templeinfo.buildFloor")}}</th>
              <!-- 层 -->
              <td>{{moreInfo.buildFloor}}{{$t("templeinfo.c")}}</td>
              <!-- 建筑面积 -->
              <th>{{$t("templeinfo.buildArea")}}</th>
              <td>{{moreInfo.buildArea}}m²</td>
            </tr>
            <tr>
              <!-- 庙区宽度 -->
              <th>{{$t("templeinfo.districtWidth")}}</th>
              <td>{{moreInfo.districtWidth}}m</td>
              <!-- 庙区长度 -->
              <th>{{$t("templeinfo.districtLength")}}</th>
              <td>{{moreInfo.districtLength}}m</td>
            </tr>
            <tr>
              <!-- 庙区面积 -->
              <th>{{$t("templeinfo.districtArea")}}</th>
              <td>{{moreInfo.districtArea}}m²</td>
              <!-- 建筑数量 -->
              <th>{{$t("templeinfo.buildNum")}}</th>
              <!-- 座 -->
              <td>{{moreInfo.buildNum}}{{$t("templeinfo.s")}}</td>
            </tr>
            <tr>
              <!-- 建筑风格 -->
              <th>{{$t("templeinfo.buildStyle")}}</th>
              <td>{{moreInfo.buildStyle}}</td>
              <!-- 建筑结构类型 -->
              <th>{{$t("templeinfo.buildType")}}</th>
              <!-- <td>{{moreInfo.buildType}}</td> -->
              <td>{{common.dictionary("建筑结构类型", moreInfo.buildType)}}</td>
            </tr>
            <tr>
              <!-- 建筑布局 -->
              <th>{{$t("templeinfo.bulidLayout")}}</th>
              <!-- <td>{{moreInfo.bulidLayout}}</td> -->
              <td>{{common.dictionary("建筑布局", moreInfo.bulidLayout)}}</td>
              <!-- 墙体材料 -->
              <th>{{$t("templeinfo.wallType")}}</th>
              <!-- <td>{{moreInfo.wallType}}</td> -->
              <td>{{common.dictionary("墙体材料", moreInfo.wallType)}}</td>
            </tr>
            <tr>
              <!-- 屋瓦 -->
              <th>{{$t("templeinfo.watts")}}</th>
              <!-- <td>{{moreInfo.watts}}</td> -->
              <td>{{common.dictionary("屋瓦", moreInfo.watts)}}</td>
              <!-- 屋顶 -->
              <th>{{$t("templeinfo.roof")}}</th>
              <!-- <td>{{moreInfo.roof}}</td> -->
              <td>{{common.dictionary("屋顶", moreInfo.roof)}}</td>
            </tr>
            <tr>
              <!-- 雀替纹样 -->
              <th>{{$t("templeinfo.texture")}}</th>
              <!-- <td>{{moreInfo.texture}}</td> -->
              <td>{{common.dictionary("雀替纹样", moreInfo.texture)}}</td>
              <!-- 窗的形式 -->
              <th>{{$t("templeinfo.window")}}</th>
              <!-- <td>{{moreInfo.window}}</td> -->
              <td>{{common.dictionary("窗的形式", moreInfo.window)}}</td>
            </tr>
            <tr>
              <!-- 柱子形式 -->
              <th>{{$t("templeinfo.pillarsStyle")}}</th>
              <!-- <td>{{moreInfo.pillarsStyle}}</td> -->
              <td>{{common.dictionary("柱子形式", moreInfo.pillarsStyle)}}</td>
              <!-- 柱子材料 -->
              <th>{{$t("templeinfo.pillarsMaterial")}}</th>
              <!-- <td>{{moreInfo.pillarsMaterial}}</td> -->
              <td>{{common.dictionary("柱子材料", moreInfo.pillarsMaterial)}}</td>
            </tr>
            <tr>
              <!-- 柱础 -->
              <th>{{$t("templeinfo.pillarsBasis")}}</th>
              <!-- <td>{{moreInfo.pillarsBasis}}</td> -->
              <td>{{common.dictionary("柱础", moreInfo.pillarsBasis)}}</td>
              <!-- 柱子装饰 -->
              <th>{{$t("templeinfo.pillarsDecoration")}}</th>
              <!-- <td>{{moreInfo.pillarsDecoration}}</td> -->
              <td>{{common.dictionary("柱子装饰", moreInfo.pillarsDecoration)}}</td>
            </tr>
            <tr>
              <!-- 屋脊 -->
              <th>{{$t("templeinfo.ridge")}}</th>
              <!-- <td>{{moreInfo.ridge}}</td> -->
              <td>{{common.dictionary("屋脊", moreInfo.ridge)}}</td>
              <!-- 屋脊装饰 -->
              <th>{{$t("templeinfo.ridgeDecoration")}}</th>
              <!-- <td>{{moreInfo.ridgeDecoration}}</td> -->
              <td>{{common.dictionary("屋脊装饰", moreInfo.ridgeDecoration)}}</td>
            </tr>
            <tr>
              <!-- 铺地 -->
              <th>{{$t("templeinfo.floor")}}</th>
              <!-- <td>{{moreInfo.floor}}</td> -->
              <td>{{common.dictionary("铺地", moreInfo.floor)}}</td>
              <!-- 建筑支撑结构 -->
              <th>{{$t("templeinfo.support")}}</th>
              <!-- <td>{{moreInfo.support}}</td> -->
              <td>{{common.dictionary("建筑支撑结构", moreInfo.support)}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import ImgList from "./ImgList.vue";
import AllInfo from "./AllInfo.vue";
export default {
  name: "MoreInfo",
  components: {
    ImgList,
    AllInfo,
  },
  props: {
    info: Object,
  },
  data() {
    return {
      isShow: false,
      moreInfoShow: false,
      moreInfo: {}, //详细信息
      templeData: {},
      clickInfo: {},
    };
  },
  watch: {
    info: {
      deep: true,
      handler(newVal, oldVal) {
        this.templeData = newVal;
      },
    },
  },
  mounted() {
    // this.fn1(2);
  },
  methods: {
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
      this.moreInfoShow = false;
    },
    zoomIn() {
      let coordinates = [this.templeData.latitude, this.templeData.longitude];
      this.$emit("zoomIn", coordinates);
      this.moreInfoShow = false;
    },

    zoomOut() {
      let coordinates = [this.templeData.latitude, this.templeData.longitude];
      this.$emit("zoomOut", coordinates);
      this.moreInfoShow = false;
    },

    getMoreInfo() {
      this.clickInfo = this.templeData;
      this.$refs.moreinfoRef.show();
      return;

      this.moreInfoShow = !this.moreInfoShow;
      if (this.moreInfoShow) {
        let pardata = { templeID: this.templeData.id };
        // this.$Loading.show();
        this.http.From("temple/getTempleInfo", pardata).then((res) => {
          //  this.$Loading.hide();
          if (res.code == "0") {
            this.moreInfo = res.data;
            // console.log(this.moreInfo);
            // this.$message({
            //   message: "获取详细信息成功",
            //   type: "success",
            // });
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "../assets/css/_common.scss";

.close_btn {
  color: $c-main;
  font-size: $f-hug;
  margin: $m-lit;
  text-align: right;

  i {
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: rotate(180deg);
      color: $c-second;
    }
  }
}
// 左信息
.left_info {
  z-index: 100;
  width: 20rem;
  height: calc(100vh - $head-height);
  overflow: hidden;
  left: 0;
  top: $head-height;
  position: absolute;
  border-radius: $r-min 0 0 $r-min;
  background-color: $c-glass-white;
  backdrop-filter: $d-glass;
  border-left: $b-glass;
  box-shadow: $shadow;
  transition: margin-right 0.5s;
  .left_menu_item_carousel {
    width: 90%;
    margin: $m-lit auto;
    // padding: $m-mid;
    height: 12rem;
    overflow: hidden;
  }

  .left_menu_item {
    width: 90%;
    margin: $m-lit auto;
    padding: $m-mid;
    .left_btn {
      font-size: $f-lit;
      display: flex;
      justify-content: space-around;
      align-items: center;
      span {
        opacity: 0.8;
        cursor: pointer;
        &:hover {
          color: $c-main;
        }
      }
    }

    .table_box {
      max-height: 26rem;
      overflow: hidden;
      overflow-y: auto;
      border-radius: $r-min;
      table {
        width: 100%;
        color: $c-text-main;
        // border: 1px solid $c-main-light;
        tr,
        th,
        td {
          border-bottom: 1px solid $c-main-light;
          // line-height: 1.5rem;
          font-size: $f-lit;
          padding: 0;
          margin: 0;
        }
        th {
          // border-right: 1px solid $c-main-light;

          width: 6rem;
        }
      }
    }
  }
  .el-carousel {
  }
}
.clicked {
  color: $c-main;
}

.more_info {
  z-index: 100;
  width: 30rem;
  height: calc(100vh - $head-height);
  left: 20rem;
  top: $head-height;
  position: absolute;
  padding-top: 3rem;
  box-sizing: border-box;
  border-radius: $r-min 0 0 $r-min;
  background-color: $c-glass-white;
  backdrop-filter: $d-glass;
  border-left: $b-glass;
  box-shadow: $shadow;
  transition: all 0.3s;

  .menu_item {
    width: 95%;
    margin: $m-lit auto;
    padding: $m-mid;

    .more_title {
      color: $c-main;
    }
    .more_table {
      table {
        width: 100%;
        color: $c-text-main;
        // border: 1px solid $c-main-light;
        border-collapse: collapse;
        tr,
        th,
        td {
          border: 1px solid $c-main-light;
          line-height: 1.5rem;
          font-size: $f-lit;
          padding: 0;
          margin: 0;
        }
        th {
          // border-right: 1px solid $c-main-light;
          width: 6rem;
        }
      }
    }
  }
}
</style>
